import React, { useEffect, useState, useCallback } from 'react';

import scrollToTop from 'helpers/scrollToTop';
import { IconWrapper, ScrollToTopBar, UpButton } from './BackToTop.style';
import useMedia from 'hooks/useMedia';
import debounce from 'lodash.debounce';

import { ReactComponent as IconCaret } from 'icons/icon-caret.svg';

interface IBackToTopProps {
  bottomMargin?: string;
}

const BackToTop: React.FC<IBackToTopProps> = ({ bottomMargin }) => {
  const isFullScreen = useMedia('(min-width: 1440px)');
  const [isBottom, setIsBottom] = useState(false);
  const [isTop, setIsTop] = useState(true);
  const [isVisible, setIsVisible] = useState(false);

  const debouncedSetIsVisible = useCallback(
    debounce(() => setIsVisible(true), 150),
    []
  );

  const onScroll = (): any => {
    setIsVisible(false);
    setIsTop(window.scrollY <= 340);
    setIsBottom(
      window.innerHeight + window.scrollY + (isFullScreen ? 200 : 280) >=
        document.body.offsetHeight
    );
    debouncedSetIsVisible();
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return (): any => window.removeEventListener('scroll', onScroll);
  });

  return (
    <ScrollToTopBar
      isTop={isTop}
      isBottom={isBottom}
      onClick={scrollToTop}
      isVisible={isVisible}
      data-pw="backToTop"
      bottomMargin={bottomMargin}
    >
      <UpButton tabIndex={isTop ? null : -1} href="#header">
        <IconWrapper>
          <IconCaret />
        </IconWrapper>
      </UpButton>
    </ScrollToTopBar>
  );
};

export default BackToTop;
